export default "__VITE_ASSET__sRTwCN3o__"